const langCodes = ['en', 'sv', 'nb', 'fi', 'da'];
export const getLangCode = ($el) => {
    const code = $el.closest('[lang]')?.getAttribute('lang')?.toLowerCase()?.split('-')[0]?.replace('no', 'nb') || '';
    if (langCodes.some((x) => x === code)) {
        return code;
    }
    return 'en';
};
